'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dImport$002dState$0024 from "./mealorama.-Import-State$.js";
import * as $j_mealorama$002e$002dRecipe$002dSearch from "./mealorama.-Recipe-Search.js";
var $p;
/** @constructor */
function $c_Lmealorama_RecipeSearch$() {
  this.alZ = null;
  this.am0 = false;
}
export { $c_Lmealorama_RecipeSearch$ as $c_Lmealorama_RecipeSearch$ };
$p = $c_Lmealorama_RecipeSearch$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_RecipeSearch$;
/** @constructor */
function $h_Lmealorama_RecipeSearch$() {
}
export { $h_Lmealorama_RecipeSearch$ as $h_Lmealorama_RecipeSearch$ };
$h_Lmealorama_RecipeSearch$.prototype = $p;
$p.a1R = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_mealorama$002e$002dImport$002dState$0024.$s_Lmealorama_ImportState$__complete__Lmealorama_ImportState(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_mealorama$002e$002dImport$002dState$0024.$s_Lmealorama_ImportState$__title__Lmealorama_ImportState(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
});
$p.ab3 = (function() {
  if ((!this.am0)) {
    this.alZ = new $j_mealorama$002e$002dRecipe$002dSearch.$c_Lmealorama_RecipeSearch(0, 20, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_List$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), $m_Lmealorama_RecipeSearch$().a1R(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
    this.am0 = true;
  }
  return this.alZ;
});
$p.aSr = (function(x$0) {
  return new $j_mealorama$002e$002dRecipe$002dSearch.$c_Lmealorama_RecipeSearch((x$0.g(0) | 0), (x$0.g(1) | 0), x$0.g(2), x$0.g(3), x$0.g(4), x$0.g(5), x$0.g(6), x$0.g(7), x$0.g(8), x$0.g(9));
});
var $d_Lmealorama_RecipeSearch$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_RecipeSearch$, "mealorama.RecipeSearch$", ({
  GN: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_RecipeSearch$ as $d_Lmealorama_RecipeSearch$ };
var $n_Lmealorama_RecipeSearch$;
function $m_Lmealorama_RecipeSearch$() {
  if ((!$n_Lmealorama_RecipeSearch$)) {
    $n_Lmealorama_RecipeSearch$ = new $c_Lmealorama_RecipeSearch$();
  }
  return $n_Lmealorama_RecipeSearch$;
}
export { $m_Lmealorama_RecipeSearch$ as $m_Lmealorama_RecipeSearch$ };
//# sourceMappingURL=mealorama.-Recipe-Search$.js.map
